<div class="flex flex-col h-full flex-1 min-h-0">

  <div class="flex justify-center items-center mb-4 mt-4">
    <elcia-period-navigator (periodChange)="setPeriod($event)" [initialDate]="periodStore.period().startDate"/>
  </div>

  <div class="flex h-full gap-6">
    <elcia-side-nav [items]="navItems" [activeValue]="activeView()" (valueChange)="activeView.set($event)"/>
    <div class="h-full flex-1">
      @if (activeView() === 'incoming') {
        @if (this.isIncomingLoading()) {
          <elcia-loader/>
        } @else {

          <elcia-incoming-invoices-grid (onDownloadAttachment)="downloadAttachments($event)"
                                        (onDownloadInvoice)="downloadInvoicePeppol($event)"
                                        [incomingInvoices]="this.incomingInvoices()"/>
        }
      } @else if (activeView() === 'outgoing') {
        @if (this.isOutgoingLoading()) {
          <elcia-loader/>
        } @else {
          <elcia-outgoing-invoices-grid (onDownloadAttachment)="downloadAttachments($event)"
                                        (onDownloadInvoice)="downloadInvoicePeppol($event)"
                                        [outgoingInvoices]="this.outgoingInvoices()"/>
        }
      } @else if (activeView() === 'incoming-credit-notes') {
        @if (this.isIncomingCreditNotesLoading()) {
          <elcia-loader/>
        } @else {
          <elcia-incoming-credit-notes-grid (onDownloadAttachment)="downloadCreditNoteAttachments($event)"
                                            (onDownloadCreditNote)="downloadCreditNotePeppol($event)"
                                            [incomingCreditNotes]="this.incomingCreditNotes()"/>
        }
      } @else {
        @if (this.isOutgoingCreditNotesLoading()) {
          <elcia-loader/>
        } @else {
          <elcia-outgoing-credit-notes-grid (onDownloadAttachment)="downloadCreditNoteAttachments($event)"
                                            (onDownloadCreditNote)="downloadCreditNotePeppol($event)"
                                            [outgoingCreditNotes]="this.outgoingCreditNotes()"/>
        }
      }
    </div>
  </div>

</div>
